import { useState } from 'react';

import { postSettlement } from 'PrivateAPI';

export const useFsl = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<Error|null>(null);
  const [success, setSuccess] = useState(false);

  const executePostSettlement = async (postSettlementPayload: any) => {
    setLoading(true);
    setError(null);
    setSuccess(false);

    try {
      const response = await postSettlement(postSettlementPayload);
      setSuccess(true);
      return response;
    } catch (err) {
      setError(err as Error);
      return Promise.reject(err);
    } finally {
      setLoading(false);
    }
  };

  return { error, executePostSettlement, loading, success };
};
